// extracted by mini-css-extract-plugin
export default {"wrapper":"PricesSpecial-module--wrapper--72428","text":"PricesSpecial-module--text--ac17d","subtext":"PricesSpecial-module--subtext--baba1"};